import { useQuery } from "@apollo/client/react";
import { useSchedulerState } from "hooks/state";
import useTimeZone from "hooks/useTimeZone";
import { GetAllBlocks } from "./block.gql";

export default function useGetBlocks() {
  const {
    state: { dataTimeRange },
  } = useSchedulerState();
  const { overrideToSiteTimeZone } = useTimeZone();

  const { data, loading, error, fetchMore } = useQuery(GetAllBlocks, {
    variables: {
      endsAt: overrideToSiteTimeZone(dataTimeRange.endDate),
      startsAt: overrideToSiteTimeZone(dataTimeRange.startDate),
    },
  });

  return {
    blocks: data?.blocks,
    data,
    error,
    loading,
    refetch: ({ dataTimeRange: newDataTimeRange } = {}) => {
      const actualStart = newDataTimeRange?.startDate || dataTimeRange.startDate;
      const actualEnd = newDataTimeRange?.endDate || dataTimeRange.endDate;

      return fetchMore({
        variables: { endsAt: overrideToSiteTimeZone(actualEnd), startsAt: overrideToSiteTimeZone(actualStart) },
      });
    },
  };
}
